import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Grid,
  LinearProgress,
  Fab,
  Typography,
  Input,
  Card,
  CardMedia,
  CardContent
} from '@material-ui/core';

import Dialog from '../Dialog';
import { inputFieldNames } from '../../constants';
import FancyDropDown from '../FancyDropDown';
import { hazardStatus } from '../../constants';

import { Attachment as AttachmentIcon } from '@material-ui/icons';
import Attachments from '../Attachments';
import CardAttachments from '../CardAttachments';
import config from '../../constants/blob_config.json';
import DocumentListDialog from '../../containers/DocumentListDialog';

import LibraryDocumentList from '../LibraryDocumentList';
import {addDocumentToArray, removeDocumentFromArray} from "../../mappers/libraryDocumentMapper";
import HazardConsequncesDialog  from "../HazardConsequncesDialog";

import Image from "react-image-enlarger";

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  },
  picker: {
    margin: 0,
    padding: 0
  },
  addAttachmentFab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  fab: {
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
    width: 210,
    height: '36px !important',
    borderWidth: 1.3,
    flex: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  card: {
    cursor: "pointer",
    height: 220,
    margin: 'auto',
    width: '100%'
  }

}));

const CreateEditHazardFormUi = (props) => {
  const {
    openDialog,
    isSaving,
    onHandleInputChange,
    openCreateHazardDialog,
    handleSubmit,
    title,
    hazard,
    documents,
    actionButtonText = 'Add',
    handleRemoveAttachment,
    allAttachments,
    canEditDocuments,
    openDocumentListDialog
  } = props;

  const hiddenFileInput = React.createRef();

  const [zoomed, setZoomed] = React.useState(false);

  const [consDialogOpen, setConsDialogOpen] = React.useState(false);

  const [isInitialScore, setIsInitialScore] = React.useState(true);

  const classes = useStyles();

  const onDialogClose = () => {
    openCreateHazardDialog(false);
  };

  const handleInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.LAST_HELD_DATE ||
      inputfieldName === inputFieldNames.NEXT_EVENT_DATE
    ) {
      onHandleInputChange(e, inputfieldName);
    } else {
      onHandleInputChange(e.target.value, inputfieldName);
    }
  };

    const handleClick = event => {
    hiddenFileInput.current.children[0].click();
  };

  const onAttachmendAdded = (event) => {
    event.preventDefault();
    const { handleAttahmentChange } = props;
    const file = event.target.files[0];
    const newObj = { newlyAdded: true, removed: false, fileData: file, name: file.name };
    handleAttahmentChange(newObj, inputFieldNames.HAZARD_ATTACHMENT);
    hiddenFileInput.current.children[0].value = null;
  };

  const handleDocumentSelected = (documentLink) => {
    const {document} = hazard;
    const updatedDocument = addDocumentToArray(document, documentLink);
    onHandleInputChange(updatedDocument, inputFieldNames.HAZARD_DOCUMENT);
  };

  const handleDocumentRemove = (documentToRemove) => {
    const {document} = hazard;
    const updatedDocument = removeDocumentFromArray(document, documentToRemove);
    onHandleInputChange(updatedDocument, inputFieldNames.HAZARD_DOCUMENT);
  }

  const onDocumentListDialogOpen = () => {
    openDocumentListDialog(true);
  };

  const handleConsequenceImageClick = (isInitial) => {

    setIsInitialScore(isInitial);
    setConsDialogOpen(true);
  }

  const handleConsequenceDialogClose = () => {
    
    setConsDialogOpen(false);
  }

  const onConsequencesSubmit = (item) => {

    if(isInitialScore === true){
      onHandleInputChange(item.likelihood, inputFieldNames.INITIAL_RISK_LIKELIHOOD);
      onHandleInputChange(item.consequnces, inputFieldNames.INITIAL_RISK_CONSEQUENCE);
    }
    else{

      onHandleInputChange(item.likelihood, inputFieldNames.FINAL_RISK_LIKELIHOOD);
      onHandleInputChange(item.consequnces, inputFieldNames.FINAL_RISK_CONSEQUENCE);

    }

    setConsDialogOpen(false);

  }

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth ={false}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Grid container className={classes.formContainer} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  id="description"
                  label="Description"
                  multiline
                  rows={2}
                  fullWidth
                  variant="outlined"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.DESCRIPTION)
                  }
                  value={hazard.description}
                  required={true}
                />
              </Grid>

              <Grid item xs={8}>
            <Card className={classes.card}  onClick={() => handleConsequenceImageClick(true)}>
                  <CardMedia
                    component="img"
                    image="https://hastrak.blob.core.windows.net/common-media/riskFinal.PNG"
                    alt="Hazard consequences"
                    style = {{height: 152, width: '100%'}}
                  />
                            <CardContent>
                      <Typography gutterBottom variant="h5" component="div" color = 'primary'>
                        Select initial score
                      </Typography>
                    </CardContent>
                </Card>
          </Grid>

          <Grid item xs={4}></Grid>

              <Grid item xs={6}>
                <TextField
                  id="initialScore"
                  aria-readonly
                  label="Initial Score"
                  value={
                    hazard.initialRiskLikelihood * hazard.initialRiskConsequence
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} />

<Grid item xs={8}>
<Card className={classes.card}  onClick={() => handleConsequenceImageClick(false)}>
                  <CardMedia
                    component="img"
                    image="https://hastrak.blob.core.windows.net/common-media/riskFinal.PNG"
                    alt="Hazard consequences"
                    style = {{height: 152, width: '100%'}}
                  />
                            <CardContent>
                      <Typography gutterBottom variant="h5" component="div" color = 'primary'>
                        Select final score
                      </Typography>
                    </CardContent>
                </Card>
          </Grid>

          <Grid item xs={4}></Grid>



              <Grid item xs={6}>
                <TextField
                  id="finalScore"
                  aria-readonly
                  label="Final Score"
                  value={
                    hazard.finalRiskLikelihood * hazard.finalRiskConsequence
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}></Grid>


              <Grid item xs={6}>
                <FancyDropDown
                  htmlId="hazardStatus"
                  label="Hazard Status"
                  margin="normal"
                  value={hazard.status}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.HAZARD_STATUS)
                  }
                  items={hazardStatus.hazardStatus.filter((x) => x.id !== 4)}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField="value"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="reviewFrequency"
                  label="Review Frequency (in months)"
                  type="number"
                  inputProps={{ min: 0 }}
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.FREQUENCY)
                  }
                  value={hazard.reviewFrequency || ''}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  id="department"
                  label="Department"
                  fullWidth
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.HAZARD_DEPARTMENT)
                  }
                  value={hazard.department}
                />
              </Grid>

              {/***************** Attachment ******************/}
              <Grid item xs={12} className={classes.gridItem}>
                <Typography className={classes.label}>Attachments</Typography>
              </Grid>
              <Grid item xs={12} className={classes.gridItem}>
                <Fab
                  id="addAttachmentBtn"
                  color="primary"
                  variant="extended"
                  aria-label="add"
                  onClick={handleClick}
                  className={`${classes.addAttachmentFab} ${classes.button}`}
                >
                  <AttachmentIcon className={classes.extendedIcon} />
                  Add attachment
                  <Input
                    type="file"
                    ref={hiddenFileInput}
                    multiple={false}
                    onChange={onAttachmendAdded}
                    style={{ display: 'none' }}
                  />
                </Fab>
              </Grid>
              {allAttachments && (
                <Grid item xs={12} className={classes.gridItem}>
                  <CardAttachments
                    allAttachments={allAttachments}
                    onRemoveAttachment={handleRemoveAttachment}
                  />
                </Grid>
              )}

 {/***************** Document ******************/}
{canEditDocuments ? (
                <Grid item xs={9}>
                  <TextField
                    type="text"
                    placeholder="Browse document"
                    defaultValue={hazard.document}
                    variant="outlined"
                    inputProps={{ readOnly: true }}
                    fullWidth
                    value={hazard.document}
                  />
                   <LibraryDocumentList commeSeperatedDocument = {hazard.document} onRemoveDocument = {handleDocumentRemove} canEdit={canEditDocuments}/>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <LibraryDocumentList commeSeperatedDocument = {hazard.document} onRemoveDocument = {handleDocumentRemove} canEdit={canEditDocuments}/>
                </Grid>
              )}
              {canEditDocuments && (
                <Grid item xs={3}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={(classes.documentButton, classes.browseButton)}
                    id="seeDocumentButon"
                    onClick={onDocumentListDialogOpen}
                  >
                    {'Browse'}
                  </Button>
                </Grid>
              )}


            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              onClick={onDialogClose}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
              id="cancelButton"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.actionButton}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
              {actionButtonText}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <DocumentListDialog handleDocumentSelected={handleDocumentSelected} showDropdown={true} />

      <HazardConsequncesDialog  open = {consDialogOpen}  handleClose = {handleConsequenceDialogClose}  handleSubmit = {onConsequencesSubmit} />


    </React.Fragment>
  );
};

export default CreateEditHazardFormUi;
